import { DateHelper, Model } from "@bryntum/schedulerpro";

const dayNames = DateHelper.getDayNames();

export class NonWorkingTime extends Model {
  static get $name() {
    return "NonWorkingTime";
  }

  static get fields() {
    return [
      { name: "isDefault", dataSource: "is_default", persist: false, readOnly: true, type: "boolean" },
      { name: "dayId", dataSource: "day", type: "number" },
      { name: "allDay", dataSource: "all_day", type: "boolean" },
      { name: "beginTime", dataSource: "begin_time", type: "string" },
      { name: "endTime", dataSource: "end_time", type: "string" },
    ];
  }

  get endTime() {
    return this.get("endTime") ? new Date(this.get("endTime")): null;
  }

  set endTime(value) {
    this.set("endTime", value);
  }

  get beginTime() {
    return this.get("beginTime") ? new Date(this.get("beginTime")): null;
  }

  set beginTime(value) {
    this.set("beginTime", value);
  }

  get begin() {
    return this.beginTime ? DateHelper.format(new Date(this.beginTime), "HH:mm"): null;
  }

  set begin(value) {
    this.set("beginTime", value ? value.toTimeString().slice(0, 5) : "");
  }

  get end() {
    return this.endTime ? DateHelper.format(new Date(this.endTime), "HH:mm"): null;
  }

  set end(value) {
    this.set("endTime", value ? value.toTimeString().slice(0, 5) : "");
  }

  get dayName() {
    return dayNames[this.get("dayId")];
  }

  set dayName(value) {
    const dayIdx = dayNames.findIndex((d) => d === value);
    this.set("dayId", dayIdx);
  }
}

NonWorkingTime.exposeProperties();
